import { Icon, TooltipHost } from '@fluentui/react';
import styles from './HeadingWithDecoration.module.scss';

interface IProps {
  text: string;
  iconName?: string;
  tooltipText?: string;
  showIcon?: boolean;
}

export const HeadingWithDecoration = ({ text, iconName, tooltipText, showIcon }: IProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.headingCursor}></div>
      <h3>{text}
      {showIcon && 
      <TooltipHost content={tooltipText || ''}>
      <Icon className={styles.icon} iconName={iconName} />
      </TooltipHost>}
      </h3>
    </div>
  );
};
